// extracted by mini-css-extract-plugin
var _1 = "UserInvitationFormActions-modulecheckboxLabel__MZtsu";
var _2 = "UserInvitationFormActions-modulecheckboxWrapper__WgVVL";
export { _1 as "checkboxLabel", _2 as "checkboxWrapper" }
